export default {
  contracts: {
    activeContracts: 'アクティブな契約',
    productsAndHours: '製品範囲と残りサポート時間',
    supported: '対応',
    notSupported: '非対応',
    contact: 'マネジャー'
  },
  states: {
    OPEN: 'オープン',
    AWAITING_REPLY: '返答待ち',
    CLOSED: 'クローズ済み',
    FEEDBACK_REQUIRED: '要フィードバック',
    onlyRequired: '要アクションのみ表示',
    onlyWorkRequests: '作業リクエストの承認のみを表示'
  },
  common: {
    New: '新規',
    Open: '開く',
    Pending: '保留中',
    Closed: 'クローズ済',
    create: '作成',
    cancel: 'キャンセル',
    goBack: '戻る',
    close: 'クローズ',
    goToMain: 'メインページへ戻る'
  },
  property: {
    name: 'プロパティ',
    allProperties: 'すべてのプロパティ',
    selectProperty: 'プロパティを選択'
  },
  product: {
    name: '製品',
    allProducts: 'すべての製品',
    selectProduct: '製品を選択',
    goBack: '戻る',
    noProducts: '製品がありません'
  },
  chart: {
    chooseMonth: '月を選択',
    noData: '現在の期間にデータがありません'
  },
  navigation: {
    main: 'メイン',
    interactions: 'チケット',
    contracts: '契約',
    signOut: 'サインアウト'
  },
  tickets: {
    createNewTitle: '新しいチケットを作る',
    title: 'タイトル',
    noTickets: '設定されている条件にマッチしたチケットはありません',
    search: '検索',
    createNew: '新規作成',
    reopenOrDisagree: 'いいえ',
    escalation: 'エスカレーション',
    reason: '理由',
    reopen: 'いいえ',
    escalate: 'エスカレート',
    opinionTitle: 'あなたのご意見は私たちにとって重要です！',
    opinionBody: '私たちのサポートスタッフを評価してください。',
    time: '解決までの時間',
    qualification: '技術の質',
    communication: 'コミュニケーション能力',
    sendFeedback: 'フィードバックを送る',
    leaveFeedback: 'フィードバックを辞める',
    close: '閉じる',
    alreadyHasFeedback: 'チケットフィードバック有り',
    feedbackHasBeenSent: 'フィードバックは送信されました',
    ticketHasBeenReopened: 'チケットは再オープンされました',
    ticketHasBeenEscalated: 'チケットはエスカレーションされました',
    comment: 'コメント',
    keyPlaceholder: 'メッセージを入力してください',
    approve: '許す',
    reject: 'リジェクト',
    workRequestOnContractNotification:
      '{{fullName}} 様、\n\n現在、サポート契約には {{hoursInSupportContract}} 時間の付加価値サービスが含まれています。\nチケット {{workRequestId}} を完了するには、{{hoursRequested}} 時間かかります。 \n\n上記のタスクの残高から時間を差し引くことを承認してください。\nありがとうございます\n\nよろしくお願いします。\n{{author}}',
    workRequestChargeableNotification:
      '{{fullName}} 様、\n\nこの作品はサービスに含まれておらず、契約上保証されていません。喜んでスケジュールを調整しお手伝いさせていただきます。リクエスト {{workRequestId}} を完了するには {{hoursRequested}} 時間かかると推定されます。\n\nこのリクエストを完了するための費用は {{amount}} となります。\nこのオファーは発行日から 7 日以内に有効です。 \n実際に費やした時間が元の見積もりを超える場合、追加時間の追加リクエスト フォームが承認を求めて要求者に送信されます。推定時間が元の見積もりより短い場合、元の見積もりはキャンセルされ、修正された見積もりが作成されます。 \n\n追加の作業と料金を承認してください。\n\nよろしくお願いします。\n{{author}}',
    workRequestCommentRequired: '仕事の依頼を拒否する理由を入力してください。'
  },
  severity: {
    name: '重要度',
    0: '普通',
    1: '高',
    2: 'クリティカル'
  },
  forms: {
    password: 'パスワード',
    confirmPassword: 'パスワード再入力',
    passwordsDoNotMatch: 'パスワードが合っていません',
    updatePassword: 'パスワード更新',
    askRestore: 'パスワード更新申請',
    remember: '保存する',
    restorePassword: 'パスワード復元',
    signIn: 'サインイン'
  },
  transactions: {
    date: '日付',
    type: '種類',
    comment: 'コメント',
    status: 'ステータス',
    subject: 'ワーク申請',
    name: 'トランザクションリスト',
    hours: '時間',
    viewTransactions: 'トランザクション表示',
    types: {
      WORK_REQUEST: 'ワーク申請',
      CONTRACT_ACTIVATION: '契約開始',
      CONTRACT_EXPIRATION: '契約満了',
      MANUAL_ADJUST_ADD: 'マニュアル調整 - 追加',
      MANUAL_ADJUST_DEDUCT: 'マニュアル調整 - 削除',
      TRANSFER_PROPERTY: 'プロパティ移動',
      TRANSFER_PRODUCT: '製品移動'
    }
  },
  transactionDetail: {
    name: 'トランザクション詳細',
    num: '番号',
    insertTime: '作成日',
    requestorName: '申請者',
    subject: '題名',
    status: 'ステータス',
    acceptTime: '許可日',
    cancelTime: 'キャンセル日',
    hours: '時間',
    hourType: '時間種類',
    workText: 'ワーク詳細',
    plannedDate: '予定日'
  },
  statuses: {
    Approved: '許可',
    Pending: '保留',
    Cancelled: 'キャンセル済み'
  },
  hoursTypes: {
    契約に含む: '契約に含む',
    インストール時間: 'インストール時間',
    予防訪問: '予防訪問',
    Chargeable: '請求可'
  },
  errors: {
    unknown: '不明なエラー',
    1000: '申請エラー',
    1001: '申請エラー',
    1: 'ログイン名又はパスワードが違います',
    2: 'セッションが切れました',
    3: '不明なプロパティ',
    4: '不明な製品',
    7: '不明な交流',
    8: '交流クローズ済み',
    11: 'アクセス違反',
    12: '不明なワーク申請'
  }
}
